module.exports = "https://cdn.dove.it/_next/static/public/assets/happy-couple-house.bb2df0e5eca40ed3d4200e22dfe6a53b.jpg";